//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FormOne from "./Form-1";
import FormTwo from "./Form-2";
import FormThree from "./Form-3";
import Preview from "./Preview";
import WelcomeMessage from "./WelcomeMessage";

const formFields = [
  { label: "Henry Schein Account Number", key: "henryscheinaccount" },
  { label: "Title", key: "title" },
  { label: "Practice Owner Name", key: "practiceOwnerName" },
  { label: "Point of Contact", key: "pointOfContact" },
  { label: "Office Number", key: "officeNumber" },
  { label: "Preferred Contact Number", key: "contactNumber" },
  { label: "Email", key: "email" },
  { label: "Practice Name", key: "practiceName" },
  { label: "Street Address", key: "streetAddress" },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Zip Code", key: "zipcode" },
  { label: "Select Subscription Plan", key: "subscribePlan" },
];


export default function Parent() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("1");
  const [status, setStatus] = useState("");
  const [links, setlinks] = useState("");
  const [data, setData] = useState({ db: 'US' });
  const [states, setstates] = useState({
    firstName: '',
    lastName: '',
    pointOfContact: '',
    officeNumber: '',
    contactNumber: '',
    email: '',
    practiceName: '',
    streetAddress: '',
    streetAddress2: '',
    city: '',
    state: 'Please Select',
    zipcode: '',
    subscribePlan: '',
    henryscheinaccount:localStorage.getItem('shipto'),
    title: '',
    practicefirstname: '',
    practicelastname: '',
    practiceOwnerName: '',
    signature: "",
    promocode:"",
    nameError: false,
    officeNumberError: false,
    contactNumberError: false,
    emailError: false,
    practiceNameError: false,
    streetAddressError: false,
    cityError: false,
    stateError: false,
    zipcodeError: false,
    subscribePlanError: false,
    emailInvalidError: false,
    henryscheinaccountError: false,
    titleerror: false,
    practicefirstnameerror: false,
    practicelastnameerror: false,
    signatureerror: false,
    promocodeerror:false

  });
  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(()=>{
    setlinks(location.state.data)

  },[])

  return (
    <div style={message == "4" ? { background: '#2C3345' } : { background: '#fff', height: '100vh' }}>
      {message === '1' && <FormOne setNext={setMessage} setStates={setStates} states={states} />}
      {message === '2' && <FormTwo setNext={setMessage} setStates={setStates} states={states} />}
      {message === '3' && <FormThree setNext={setMessage} setStates={setStates} states={states} links={links} />}
      {message === '4' && <Preview setNext={setMessage} setStates={setStates} formData={states} formFields={formFields}links={links}  />}
      {message === '5' && <WelcomeMessage setNext={setMessage} setStates={setStates} formData={states} formFields={formFields} />}
    </div>
  );
}